import {getBookingEngineTranslations} from "@assets/js/functions/helpers";
const translations = getBookingEngineTranslations();

export const CHOOSE_PAYMENT = 'Wybierz metodę płatności';
export const CLIMATE_TAX_ADNOTATION = translations['summary-climate-tax-annotation'];
export const CASHBACK_BALANCE_ADNOTATION = translations['summary-cashback-balance-annotation'];
export const PRICE = translations['price'];
export const PRICE_BEFORE_DISCOUNT = translations['price-before-discount'];
export const PRICE_AFTER_DISCOUNT = translations['price-after-discount'];
export const GO_TO_NEXT_STEP = translations['booking-action-forward'];
export const BOOKING_ENGINE_URI_PREFIX = 'booking';
export const YOUR_RESERVATIONS = translations['box-heading-reservations'];
export const TO_PROCEED_FILL_OPTIONS = 'Aby przejść dalej, wybierz opcję płatności oraz ofertę';
export const ERROR_REFRESH_PAGE = 'Wystąpił błąd. Proszę odświeżyć stronę.';
export const DELETE_DISCOUNT_CODE = translations[ 'voucher-delete' ];
export const RATEPLAN_DESCRIPTION = 'Jeśli nie zrezygnujesz...';
export const CHECKIN = translations['checkin']
export const CHECKOUT = translations['checkout'];

